export const isCidadaoPuericultura = (idadeCidadaoEmAnos: number): boolean => idadeCidadaoEmAnos < 19
